<div [formGroup]="formGroup">
  <input type="time" [formControlName]="field.name" [id]="field.name" />
</div>
